import * as React from "react";
import clsx from "clsx";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import "debounce";
import "tabbable";
import { useResponsiveProps } from "../../helpers/helper/hooks/use-responsive-props.mjs";
import { List } from "../../list/list/list.mjs";
import { ListItem } from "../../list/list-item/list-item.mjs";
const HeaderLanguages = (props) => {
  const { responsive, ...rest } = props;
  return responsive ? /* @__PURE__ */ React.createElement(HeaderLanguagesResponsive, { ...rest, responsive }) : /* @__PURE__ */ React.createElement(HeaderLanguagesInner, { ...rest });
};
const HeaderLanguagesResponsive = (props) => {
  const { responsive, ...rest } = props;
  const responsiveProps = useResponsiveProps({ responsive });
  return /* @__PURE__ */ React.createElement(HeaderLanguagesInner, { ...rest, ...responsiveProps });
};
const HeaderLanguagesInner = (props) => {
  const languageItemBEM = (item) => {
    const classArray = ["header__languages-item"];
    if (item.current) {
      classArray.push("is-current");
    }
    return classArray.join(" ");
  };
  const getItems = () => {
    return props.items.map((item, index) => {
      const { label, current, ...rest } = item;
      return /* @__PURE__ */ React.createElement(ListItem, { className: languageItemBEM(item), key: index }, /* @__PURE__ */ React.createElement(
        Anchor,
        {
          ...rest,
          isUnderlined: false,
          isTextColor: true,
          className: "header__languages-link",
          attributes: {
            "aria-current": current ? "true" : void 0
          }
        },
        label
      ));
    });
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: clsx("header__languages", {
        ["header__languages--".concat(props.location)]: !!props.location
      })
    },
    /* @__PURE__ */ React.createElement(List, { type: "unstyled", direction: "inline", spacing: "none", className: "header__languages-list" }, getItems())
  );
};
export {
  HeaderLanguages
};
